import styled from "styled-components"

interface IProgressBarAttrs {
  disableAnimation: boolean
  isActive: boolean
  progressPercent: number
}

interface IProgressBar {
  disableAnimation: boolean
  isActive: boolean
  width?: string
  progressPercent: number
}

export const ProgressBar = styled.div.attrs<IProgressBarAttrs>((props) => ({
  width: props.progressPercent ? `${props.progressPercent}%` : "0%",
}))<IProgressBar>`
  background-color: #bf4320;
  height: 100%;
  transition: ${(props) =>
    props.disableAnimation ? "none" : "opacity 0.5s ease, width 1s linear;"};
  width: ${(props) => props.width};
  opacity: ${(props) => (props.isActive ? "1" : "0")};
`
